@if (!isEmptyLabel() && title()) {
    <label
        part="native"
        class="bazis-label__native"
    >
        <slot name="labelStart"></slot>
        {{ title() }}
        @if (required()) {
            <span class="bazis-label__required"> * </span>
        }
        <slot name="labelEnd"></slot>
    </label>
}
@if (isEmptyLabel()) {
    <label
        part="native"
        class="bazis-label__native"
        >&nbsp;</label
    >
}
